import { render, staticRenderFns } from "./LandingHablan.vue?vue&type=template&id=725ae8d0"
import script from "./LandingHablan.vue?vue&type=script&lang=js"
export * from "./LandingHablan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports